import React, { useState, useEffect } from "react";
import SideNavigation from "../../components/dumb/projectManager/SideNavigation";
import { fetchTitles } from "../../redux/ducks/title";
import { useSelector } from "react-redux";
import useAuthEffect from "../../hook/useAuthEffect";
import useStatusThunk from "../../hook/useStatusThunk";
import Titles from "../../components/dumb/tables/Titles";

const TitlesRoute = () => {
    const [rows, setRows] = useState([]);
    const titles = useSelector(state => state.title.titles);
    const [dispatchFetchTitles, status, error] = useStatusThunk(fetchTitles);

    //Initial title data
    useAuthEffect(() => dispatchFetchTitles());

    //Row data
    useEffect(() => {
        if (status == "success") setRows(Object.keys(titles).map(ID => { return { ID, name: titles[ID].name } }));
    }, [status, titles]);

    return (
        <div className="columns-container">
            <div className="column column--sidenav">
                <SideNavigation selected="titles" />
            </div>

            <div className="column column--primary">
                <Titles rows={rows} />
            </div>
        </div>
    )
}

export default TitlesRoute;